import { ShieldOff } from "lucide-react";
import { useNavigate } from "react-router";
import { useAuth } from "@ncp/api-client";
import { useTranslation } from "@ncp/i18n";
import { Button, EmptyState } from "@ncp/ui";

export function ForbiddenPage({ permission }: { permission?: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { clear } = useAuth();
  return (
    <div className="mx-auto max-w-xl py-16">
      <EmptyState
        icon={ShieldOff}
        title={t("admin:common.permissionDenied")}
        description={permission ? <span className="font-mono text-xs">{permission}</span> : t("admin:login.noAccess")}
        action={
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => navigate("/")}>{t("admin:nav.overview")}</Button>
            <Button
              onClick={() => {
                clear();
                navigate("/login");
              }}
            >
              {t("admin:shell.signOut")}
            </Button>
          </div>
        }
      />
    </div>
  );
}
